import axios from 'axios'

export default {
  // 请求后台处理
  handle: async function (url, parma, err100000Fnc) {
    const data = await axios
      .post(url, encodeURI(JSON.stringify(parma)).replace(/\+/g, '%2B'))
      .then(function (response) {
        if (response.data && response.data.error === '000000') {
          return response.data
        } else if (response.data.error === '100000') {
          if (typeof (err100000Fnc) === 'function') {
            err100000Fnc()
          } else {
            location.reload(location)
          }
        } else {
          return response.data
        }
      })
      .catch(function () {
        return { error: '999999', msg: '网络异常！' }
      })
    return data
  }
}
